import {
	ArticleOutlined,
	AttachFileOutlined,
	DrawOutlined,
	SendOutlined,
} from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Box, IconButton, Stack } from '@mui/material';
import { useEditor } from '@tiptap/react';
import { extensions } from 'components/ui/rich-text-editor/extensions';
import { RichTextContent } from 'components/ui/rich-text-editor/rich-text-content';
import { RichTextToolbar } from 'components/ui/rich-text-editor/toolbar/rich-text-toolbar';
import { useFormikContext } from 'formik';
import { NewMessageFormValues } from '../conversation-column/conversation-message-box';

interface MessageBoxProps {
	includeSendButton?: boolean;
}

export const MessageBox = ({ includeSendButton }: MessageBoxProps) => {
	const { submitForm, isSubmitting, isValid, dirty, setFieldValue } =
		useFormikContext<NewMessageFormValues>();

	const editor = useEditor({
		extensions,
		onUpdate: ({ editor }) => {
			setFieldValue('messageText', editor.getHTML());
		},
	});

	return (
		<Stack spacing={1} flex={1} overflow="hidden">
			<Stack flex={1} overflow="hidden" spacing={1}>
				<RichTextToolbar editor={editor} />
				<RichTextContent
					editor={editor}
					flex={1}
					overflow="auto"
					border="1px solid"
					borderColor="neutral.200"
					bgcolor="neutral.50"
					borderRadius={1}
					p={1.5}
				/>
			</Stack>
			<Stack direction="row">
				<IconButton>
					<AttachFileOutlined />
				</IconButton>
				<IconButton>
					<DrawOutlined />
				</IconButton>
				<IconButton>
					<ArticleOutlined />
				</IconButton>
				<Box flex={1} />
				{includeSendButton && (
					<LoadingButton
						variant="contained"
						color="primary"
						startIcon={<SendOutlined />}
						disabled={!isValid || !dirty}
						loading={isSubmitting}
						onClick={async () => {
							await submitForm();
							editor?.commands.clearContent(true);
						}}>
						Send
					</LoadingButton>
				)}
			</Stack>
		</Stack>
	);
};
